import React from 'react';

const StatCard = ({ label, value, sub, accent }) => (
  <div className="p-6 bg-zinc-900/60 border border-zinc-800 rounded-2xl space-y-1.5">
    <p className="text-[10px] font-black uppercase tracking-widest text-zinc-600">{label}</p>
    <p className={`text-3xl font-black ${accent || 'text-white'}`}>{value}</p>
    {sub && <p className="text-[10px] font-bold text-zinc-700">{sub}</p>}
  </div>
);

const DashboardStats = ({ drops, merch }) => {
  const published = drops.filter(d => d.is_published).length;
  const drafts    = drops.filter(d => !d.is_published).length;
  const totalUnlocks = drops.reduce((a, d) => a + (d.unlock_count || 0), 0);
  const totalPlays   = drops.reduce((a, d) => a + (d.play_count || 0), 0);
  const activeMerch  = merch.filter(m => m.is_active).length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      <StatCard label="Live Drops"    value={published}    sub="Published"      accent="text-green-400" />
      <StatCard label="Drafts"        value={drafts}       sub="Unpublished" />
      <StatCard label="Total Unlocks" value={totalUnlocks} sub="All time"       accent="text-blue-400" />
      <StatCard label="Total Plays"   value={totalPlays}   sub="Streams" />
      <StatCard label="Active Merch"  value={activeMerch}  sub="Items listed"   accent="text-amber-400" />
    </div>
  );
};

export default DashboardStats;